import McRadarChart from './McRadarChart';

export default McRadarChart;
